import React, { Component } from "react";
import PageHeader from "./components/PageHeader";
import ErrorNotification from "./components/ErrorNotification";
import ProgressLine from "../BookingPortal/components/ProgressLine";

import "../../assets/less/app.less";

class PageLayout extends Component {
  render() {
    return (
      <div>
        <PageHeader />
        <ErrorNotification />
        <div className="client-portal-main container">
          <ProgressLine location={this.props.location} />
          {this.props.children}
        </div>
      </div>
    );
  }
}

export default PageLayout;



// WEBPACK FOOTER //
// ./src/modules/Layout/index.js